import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useConfig } from "../context/ConfigContext";

export default function usePageTracker() {
  const location = useLocation();
  const { config } = useConfig();

  useEffect(() => {
    if (!config) return;
    fetch(config.REACT_APP_TRACKVISIT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Api-Key": config.REACT_APP_API_KEY,
      },
      body: JSON.stringify({ path: location.pathname }),
    }).catch(() => {});
  }, [location.pathname, config]);
}
